"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
var GroupTypeEnum;
(function (GroupTypeEnum) {
    GroupTypeEnum["FOLLOWERS"] = "followers";
    GroupTypeEnum["SUBSCRIBERS"] = "subscribers";
    GroupTypeEnum["SUBSCRIPTION_LEVEL"] = "subscription_level";
})(GroupTypeEnum = exports.GroupTypeEnum || (exports.GroupTypeEnum = {}));
exports.isSubscriptionLevelGroupDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "SubscriptionLevelGroupDetails";
};
class GroupsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Group: () => `
        ... on Group {
          id
          ownerId
          name
          memberIds
          createTime
          updateTime
          system
          subject {
            subjectId
            subjectType
          }
          details {
            __typename
            ${this.getFragment("GroupDetails")}
          }
        }
      `,
            GroupDetails: () => `
        ... on SubscriptionLevelGroupDetails {
          subscriptionLevel {
            ${this.getFragment("SubscriptionLevel")}
          }
        }     
      `,
        };
    }
    search({ data }, fields) {
        return this.query("groupsSearch", { data }, this.getFragment("Group", fields));
    }
    create({ data }) {
        return this.mutate("groupsCreate", { data }, this.getFragment("Group"));
    }
    update({ data }) {
        return this.mutate("groupsUpdate", { data }, this.getFragment("Group"));
    }
    delete(id) {
        return this.mutate("groupsDelete", { id });
    }
    updateMembers({ data }) {
        return this.mutate("groupsUpdateMembers", { data }, this.getFragment("Group"));
    }
}
exports.GroupsProvider = GroupsProvider;
//# sourceMappingURL=GroupsProvider.js.map